module.exports = __webpack_public_path__ + "ebd3d236b72d05c8c339fd4193ec8dba.jpg";